var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarDoor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15.1578947px",
    viewBox: "0 0 16 15.1578947",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8F08AD2A-F6DA-4461-A9F4-BF8179159C92") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Car",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car_Icons_KLM",
    transform: "translate(-515.000000, -345.000000)",
    fill: "#00A1DE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "car-door",
    transform: "translate(515.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4736842,9.26315789 L10.9473684,9.26315789 L10.9473684,10.9473684 L13.4736842,10.9473684 L13.4736842,9.26315789 M16,15.1578947 L0,15.1578947 L0,6.73684211 L6.73684211,0 L15.1578947,0 C15.6229766,0 16,0.377023369 16,0.842105263 L16,15.1578947 M7.43578947,1.68421053 L2.38315789,6.73684211 L14.3157895,6.73684211 L14.3157895,1.68421053 L7.43578947,1.68421053 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarDoor);
export default __webpack_public_path__ + "static/media/car-door.43d8284f193c90008b8569103288b2f9.svg";
export { ForwardRef as ReactComponent };